class Product {
  constructor() {
    this.acc = [];
    this.container = document.querySelector(".m-main-product");
    JMLAB2BTheme.CompareProduct && JMLAB2BTheme.CompareProduct.setCompareButtonsState();
    JMLAB2BTheme.Wishlist && JMLAB2BTheme.Wishlist.setWishlistButtonsState();
    this.addRecentViewedProduct();

    addEventDelegate({
      context: this.container,
      selector: (window.__JMLAB2B_review_selector || '') + '.m-product-collapsible .jdgm-widget-actions-wrapper, .m-product-collapsible .spr-summary-actions-newreview',
      handler: (e) => {
      const index = e.target.closest('.m-product-collapsible').dataset.index
      setTimeout(() => {
        this.acc[Number(index)].setContentHeight()
      }, 300)},
      capture: true
    })
  }

  addRecentViewedProduct() {
    const cookies = getCookie('m-recent-viewed-products')
    let products = cookies ? JSON.parse(cookies) : []
    if (products.indexOf(JMLAB2BSettings.productHandle) === -1) {
      products.unshift(JMLAB2BSettings.productHandle)
      products = products.slice(0, 20)
      setCookie('m-recent-viewed-products', JSON.stringify(products));
    }
  }
}

// new Product();
